import LegalLayout from "@/pages/legal/LegalLayout";

const SECTIONS = [
  {
    id: "operator",
    label: "Website Operator",
    body: [
      "This website presents the wider Erenown structure, which includes independently established Erenown entities in the United Kingdom and Kosovo.",
      "Unless otherwise stated, website operation and legal website disclosures are aligned primarily with Erenown Ltd, registered in England and Wales.",
    ],
  },
  {
    id: "entities",
    label: "Erenown Entities",
    body: [
      {
        type: "mono",
        lines: [
          "Erenown Ltd",
          "Registered in England and Wales",
          "Company No. 12845592",
          "Registered Office: 83 St Marks Road, Enfield,",
          "EN1 1BJ, United Kingdom",
        ],
      },
      {
        type: "mono",
        lines: [
          "Erenown LLC",
          "Ulpianë, C2, H-III, Nr.6",
          "Bulevardi “Dëshmorët e Kombit”,",
          "Prishtinë 10000,",
          "Republic of Kosovo",
        ],
      },
    ],
  },
  {
    id: "contact",
    label: "Contact",
    body: [
      { type: "mono", lines: ["info@erenown.com"] },
    ],
  },
  {
    id: "purpose",
    label: "Website Purpose",
    body: [
      "The website provides information about Erenown, its entities, structures, brands, capabilities, and related business activities. It is intended for general professional and informational use, and to support clear communication with visitors and enquirers.",
    ],
  },
  {
    id: "no-offer",
    label: "No Automatic Offer or Binding Commitment",
    body: [
      "Website content does not by itself constitute a binding offer, legal commitment, or automatic contractual arrangement. Any commercial engagement is established only through a separately defined and agreed arrangement.",
    ],
  },
  {
    id: "ip",
    label: "Intellectual Property Notice",
    body: [
      "The website’s content, design, structure, brand names, and related materials are protected and may not be reused without permission. Reasonable viewing of the website by visitors is permitted; reproduction, redistribution, or commercial exploitation requires prior written consent.",
    ],
  },
  {
    id: "additional-documents",
    label: "Additional Documents",
    body: [
      "Additional legal and contractual documents may apply depending on the nature of enquiries, services, collaborations, or commercial arrangements. Where relevant, those documents will be shared and agreed separately.",
    ],
  },
  {
    id: "updates",
    label: "Updates",
    body: [
      "This Legal Notice may be updated from time to time. Revised versions will be posted on the website with an updated effective date.",
    ],
  },
];

export default function LegalNotice() {
  return (
    <LegalLayout
      eyebrow="Legal Notice"
      title="Legal Notice."
      originallyPublished="01 September 2020"
      lastUpdated="16 October 2021"
      intro="A formal disclosure setting out the operator of this website, the Erenown entities, and the legal context within which the site is presented."
      sections={SECTIONS}
    />
  );
}
